import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { validateEmail, validateEmailRepeat, validateNonOptional } from 'db/helpers';

@Entity()
export class FormularLeadSignup extends AdornisEntity {
  static override _class = 'FormularLeadSignup';

  @validate(nonOptional())
  @Field(type => String)
  firstName!: string;

  @validate(nonOptional())
  @Field(type => String)
  lastName!: string;

  @validate(options => {
    validateNonOptional({ key: options.key, value: options.value });
    validateEmail({ key: options.key, value: options.value });
  })
  @Field(type => String)
  email!: string;

  @validate(options => {
    validateNonOptional({ key: options.key, value: options.value });
    validateEmailRepeat({ key: options.key, email: options.target.email, emailRepeat: options.value });
  })
  @Field(type => String)
  emailRepeat!: string;

  @validate(nonOptional())
  @Field(type => Boolean)
  hasAcceptedPrivacy!: boolean;
}
